import config from '../../../config';
import { SpriteToRect, isPointInRect, debounce, clampTextToDimensions } from '../../../utils';
import { Layer } from '../tools';
import { initElectricGates } from './ElectricGate';
import { initZapperWalls } from './ZapperWalls';
import { initNaniteExpanders } from './NaniteExpanders';
import { initWarps } from './Warps';
import { initBumpers } from './Bumpers';
import { initCoins } from './Coins';
import { initPowerUps } from './PowerUps';

const IGNORED_LAYERS = [config.FLOOR, config.EXPANDERS, config.TRAIL, config.COINS, config.BEE_MONEY, config.POWER_UPS];
const COLLECTABLES = [config.COINS, config.TRAIL, config.POWER_UPS, config.BEE_MONEY];

const TILE_SIZE = config.TILE_SIZE;
const TILE_SIZE_HALF = TILE_SIZE / 2;

let soundManager;
let dataManager;

const EASY = 'EASY';
const MEDIUM = 'MEDIUM';
const HARD = 'HARD';
const INTERMISSION = 'INTERMISSION';

const ORDER = [EASY, INTERMISSION, MEDIUM, INTERMISSION, HARD, INTERMISSION];
// const ORDER = [HARD, INTERMISSION];

let progress = {};

let pool = {};

// temp htp tracker
// TODO: put this in the dataManager
let htpCompleted = false;
let levelsCleared = 0;

let beeMoneyRequired = 10;
let beeMoneyCount = 0;

let playCoinCollect = debounce(function () {
  soundManager.playSound('coin-collected');
}, 25, true);

let playBreadCrumb = debounce(function () {
  soundManager.playSound('bread-crumb');
}, 25, true);

class LevelManager {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;

    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');

    beeMoneyCount = dataManager.getSessionItem('beeMoneyCount');

    // keep track of our current level
    // this.activeLevelIndex = null;
    this.activeLevel = null;
    if (!g.isContinue) {
      levelsCleared = 0;
      progress.index = 0;
      progress.cleared = 0;
    }

    this.levelsCleared = levelsCleared;

    this.htpCompleted = htpCompleted;

    this.transitionActive = false;

    this.nextLevel = null;

    this.beeMoneyText = [];

    this.frames = this.g.cache.json.get('tilesheet').frames;

    this.addNextLevel(true);

    this.scroll = {
      prev: 0,
      current: 0,
      distance: 0,
      transition: 0,
      offset: 0
    };

    this.setCamera();

    // console.log('LevelManager.constructor', _.clone(this.scroll));

    // TODO: Don't always start on the intro htp
    if (!g.isContinue) {
      this.showHtp();
    }
  }
  getDifficulty () {
    let g = this;
    return ORDER[progress.index];
  }
  addNextLevel (isFirstLevel = false) {
    let g = this.g;
    let map = this.getMap();
    let mapLayers = map.layers;
    dataManager.setSessionItem('checkPointScore', dataManager.getScore());

    let height = map.height * TILE_SIZE;
    let layers = {};
    let exit = null;
    let yOffset = isFirstLevel ? 0 : -height;

    exit = new Phaser.Geom.Rectangle(config.CENTER_X - TILE_SIZE_HALF, 0, TILE_SIZE, TILE_SIZE);
    exit.layerName = config.EXIT;

    let level = {
      height,
      layers,
      exit,
      isFirstLevel
    };
    if (isFirstLevel) {
      this.activeLevel = level;
    } else {
      this.nextLevel = level;
    }

    _.each(mapLayers, (mapLayer) => {
      let layer = new Layer(mapLayer.name);
      layers[layer.name] = layer;
      this.paint(layer.name, mapLayer.data, layer.groups.tiles, yOffset);
    });

    if (layers[config.POWER_UPS]) {
      initPowerUps.call(this, layers[config.POWER_UPS]);
    }

    if (layers[config.COINS]) {
      initCoins.call(this, layers[config.COINS]);
    }

    if (layers[config.BUMPER]) {
      initBumpers.call(this, layers[config.BUMPER]);
    }

    if (layers[config.WARPS]) {
      initWarps.call(this, layers[config.WARPS]);
    }

    if (layers[config.ZAPPER_WALLS]) {
      initZapperWalls.call(this, layers[config.ZAPPER_WALLS]);
    }

    if (layers[config.EXPANDERS]) {
      initNaniteExpanders.call(this, layers[config.EXPANDERS]);
    }

    if (layers[config.ELECTRIC_GATE] && isFirstLevel) {
      initElectricGates.call(this, layers[config.ELECTRIC_GATE]);
    }

    // console.log('LevelManager.addNextLevel', _.clone(this.scroll));
  }
  getMap () {
    // TODO: Finish getMap logic
    let g = this.g;
    let key;
    if (g.isContinue) {
      key = dataManager.getSessionItem('lastMapKey');
    } else if (!htpCompleted) {
      key = config.MAP.HTP;
    } else {
      // TODO: create logic for getting either EASY MEDIUM or HARD maps
      let difficulty = ORDER[progress.index];
      if (progress.cleared < config.MAP_COUNT[difficulty]) {
        key = this.getKey(difficulty);
      } else {
        progress.index = progress.index + 1 < ORDER.length ? progress.index + 1 : 0;
        progress.cleared = 0;
        difficulty = ORDER[progress.index];
        key = this.getKey(difficulty);
      }
      // console.log('Difficulty', difficulty);
      soundManager.playMusic('loop-' + this.getDifficulty());
    }
    // console.log('key', key);
    this.mapKey = key;
    dataManager.setSessionItem('lastMapKey', key);
    return g.cache.json.get(key);
  }
  getKey (DIFFICULTY) {
    if (pool[DIFFICULTY] === undefined || pool[DIFFICULTY].length === 0) {
      pool[DIFFICULTY] = Phaser.Utils.Array.Shuffle(_.clone(config.MAP[DIFFICULTY]));
      // console.log('clone shuffle');
    }
    return pool[DIFFICULTY].pop();
  }
  transition () {
    let g = this.g;
    // console.log('Set beeMoneyCount', beeMoneyCount);
    dataManager.setSessionItem('beeMoneyCount', beeMoneyCount);
    dataManager.saveCoins();
    if (this.mapKey === config.MAP.HTP) {
      // console.log('htp completed');
      htpCompleted = true;
      this.htpCompleted = true;
    } else {
      levelsCleared++;
      this.levelsCleared = levelsCleared;
      progress.cleared++;
      // console.log('levelsCleared', this.levelsCleared);
    }
    this.transitionActive = true;
    this.scroll.transition = g.cameras.main.scrollY;
    // console.log('transitionStart', _.clone(this.scroll));
    g.tweens.add({
      targets: this.scroll,
      transition: '-=' + config.HEIGHT,
      duration: config.TRANSITION_DURATION,
      ease: 'Sine.easeOut'
    });
    this.addNextLevel();
    g.transitionBg();
    this.tween(this.activeLevel);
    this.tween(this.nextLevel);
    g.bile.transition();
    this.bringBeeMoneyTextToTop();
  }
  onTransitionComplete () {
    let g = this.g;
    this.destroyLevel(this.activeLevel);
    this.activeLevel = this.nextLevel;
    this.nextLevel = null;
    this.setCamera();
    this.resetLevelY();
    let layers = this.activeLevel.layers;
    if (layers[config.ELECTRIC_GATE]) {
      initElectricGates.call(this, layers[config.ELECTRIC_GATE]);
      g.player.bringToTop();
    }
    g.bile.reset();
    if (g.activePowerUp !== config.ANTACID) {
      g.bile.start();
    }
    g.bringFgToTop();
    this.transitionActive = false;
    this.bringBeeMoneyTextToTop();
    // console.log('LeveltransitionComplete', _.clone(this.scroll));
  }
  showHtp () {
    let g = this.g;
    if (this.mapKey !== 'map-0') { return; }

    this.activeLevel.textImage = g.add.sprite(config.CENTER_X, this.height - 400, 'htp-text');
    this.activeLevel.textImage.setScale(0.75);
    var tutorialString01 = g.game.localisationManager.GetString(g.game.isDesktop ? "tutorial_desktop_01" : "tutorial_mobile_01");
    var tutorialString02 = g.game.localisationManager.GetString("tutorial_02");
    this.activeLevel.text = g.add.text(config.CENTER_X, this.height - 270, tutorialString01 + "\n" + tutorialString02, { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#FFF", align: 'center', wordWrap: { width: 490 } })
    this.activeLevel.text.setOrigin(0.5);
    clampTextToDimensions(this.activeLevel.text, this.activeLevel.text.style.wordWrapWidth, 400);
  }
  updateScroll () {
    let g = this.g;
    if (g.cameras.main.scrollY > (this.height - config.HEIGHT)) {
      // console.log('out of bounds!@');
      this.scroll.current = this.height - config.HEIGHT;
      this.scroll.prev = this.height - config.HEIGHT;
      this.scroll.distance = this.height - config.HEIGHT;
      return;
    }
    if (this.transitionActive) {
      this.scroll.current = this.scroll.transition;
    } else {
      this.scroll.current = g.cameras.main.scrollY;
    }
    // console.log(this.scroll.current, this.scroll.prev);
    this.scroll.distance += this.scroll.current - this.scroll.prev;
    this.scroll.prev = this.scroll.current;
  }
  getScroll () {
    let g = this.g;
    // console.log('getScroll', this.scroll.distance + this.scroll.offset);
    return this.g.cameras.main.scrollY;// this.scroll.distance + this.scroll.offset;
  }
  getCollectables () {
    let g = this.g;
    let {
      layers
    } = this.activeLevel;

    let collectables = [];
    _.each(COLLECTABLES, (name) => {
      if (layers[name]) {
        let layer = layers[name];
        collectables.push(layer.groups.tiles);
      }
    });
    collectables = _.flatten(collectables);
    return collectables;
  }
  watch (player) {
    let g = this.g;
    let {
      layers
    } = this.activeLevel;

    this.updateScroll();
    // console.log('scroll.total', this.scroll.total);

    if (!player.active || !player.visible || this.transitionActive) {
      return;
    }

    // check magnet radius
    if (g.activePowerUp === config.MAGNET) {
      let collectables = this.getCollectables();
      let circ = new Phaser.Geom.Circle(player.x, player.y, config.MAGNET_RADIUS);
      _.each(collectables, (sprite) => {
        if (!sprite.active || sprite.collected) { return; }
        if (sprite.tween && sprite.tween.isPlaying()) {
          sprite.tween.updateTo('x', player.x, true);
          sprite.tween.updateTo('y', player.y, true);
          return;
        }
        let rect = SpriteToRect(sprite);
        if (Phaser.Geom.Intersects.CircleToRectangle(circ, rect)) {
          // sprite.setAlpha(0.25);
          sprite.tween = g.tweens.add({
            targets: sprite,
            x: player.x,
            y: player.y,
            ease: 'Sine.easeIn',
            duration: 1000
          });
        }
      });
    }

    // bee money
    if (layers[config.BEE_MONEY]) {
      let layer = layers[config.BEE_MONEY];
      _.each(layer.groups.tiles, (sprite) => {
        if (sprite.active && !sprite.collected && isPointInRect(player, SpriteToRect(sprite))) {
          beeMoneyCount = dataManager.getSessionItem('beeMoneyCount');
          beeMoneyCount = beeMoneyCount < beeMoneyRequired ? beeMoneyCount + 1 : 10;
          // console.log('Collect beeMoney', beeMoneyCount);

          let beeMoneyPoints = config.BEE_MONEY_POINTS * beeMoneyCount;
          beeMoneyPoints = g.activePowerUp === config.BOOSTER ? beeMoneyPoints * 2 : beeMoneyPoints;
          dataManager.addPoints(beeMoneyPoints);
          this.showBeeMoneyText(beeMoneyCount, beeMoneyPoints);
          soundManager.playSound('bee-money');
          if (sprite.tween) {
            sprite.tween.stop();
            sprite.tween = null;
          }
          sprite.collected = true;
          sprite.play('bee-money');
          sprite.on('animationend', () => {
            sprite.setActive(false);
            sprite.setVisible(false);
          });
        }
      });
    }

    // coins
    if (layers[config.COINS]) {
      let layer = layers[config.COINS];
      _.each(layer.groups.tiles, (sprite) => {
        if (sprite.active && !sprite.collected && isPointInRect(player, SpriteToRect(sprite))) {
          dataManager.addCoins(1);
          dataManager.addPoints(g.activePowerUp === config.BOOSTER ? config.COINS_POINTS * 2 : config.COINS_POINTS);
          playCoinCollect();
          if (sprite.tween) {
            sprite.tween.stop();
            sprite.tween = null;
          }
          sprite.collected = true;
          sprite.anims.stop();
          sprite.setFrame('rays.png');
          g.tweens.add({
            targets: sprite,
            scaleX: 0,
            scaleY: 0,
            duration: 500,
            delay: 100,
            ease: 'Sine.easeOut',
            onComplete: () => {
              sprite.setActive(false);
              sprite.setVisible(false);
            }
          });
        }
      });
    }

    // powerups
    if (layers[config.POWER_UPS]) {
      let layer = layers[config.POWER_UPS];
      _.each(layer.groups.tiles, (sprite) => {
        if (sprite.active && !sprite.collected && isPointInRect(player, SpriteToRect(sprite))) {
          if (sprite.tween) {
            sprite.tween.stop();
            sprite.tween = null;
          }
          if (sprite.isCoin) {
            dataManager.addCoins(1);
            dataManager.addPoints(g.activePowerUp === config.BOOSTER ? config.COINS_POINTS * 2 : config.COINS_POINTS);
            playCoinCollect();
            sprite.collected = true;
            sprite.anims.stop();
            sprite.setFrame('rays.png');
            g.tweens.add({
              targets: sprite,
              scaleX: 0,
              scaleY: 0,
              duration: 500,
              delay: 100,
              ease: 'Sine.easeOut',
              onComplete: () => {
                sprite.setActive(false);
                sprite.setVisible(false);
              }
            });
          } else {
            // console.log('TODO: Finish collected PowerUp Logic', sprite.frame);
            let frameName = sprite.frame.name;
            sprite.setActive(false);
            sprite.setVisible(false);
            // g.activateArmor();
            switch (frameName) {
              case '66-powerup-armor.png':
                g.activateArmor();
                break;
              case '68-powerup-x2.png':
                g.activateScoreBooster();
                break;
              case '67-powerup-magnet.png':
                g.activateMagnet();
                break;
              case '69-powerup-antacid.png':
                g.activateAntacid();
                break;
            }
          }
        }
      });
    }

    // trail crumbs
    if (layers[config.TRAIL]) {
      let layer = layers[config.TRAIL];
      _.each(layer.groups.tiles, (sprite) => {
        if (sprite.active && isPointInRect(player, SpriteToRect(sprite))) {
          dataManager.addPoints(g.activePowerUp === config.BOOSTER ? config.TRAIL_POINTS * 2 : config.TRAIL_POINTS);
          playBreadCrumb();
          if (sprite.tween) {
            sprite.tween.stop();
            sprite.tween = null;
          }
          sprite.setActive(false);
          sprite.setVisible(false);
        }
      });
    }

    // GATE BLOCKS
    if (layers[config.GATE_BLOCKS]) {
      let layer = layers[config.GATE_BLOCKS];
      _.each(layer.groups.tiles, (sprite) => {
        if (sprite.isClosed) { return; }
        if (sprite.active && isPointInRect(player, SpriteToRect(sprite))) {
          if (sprite.tween) {
            sprite.tween.stop();
            sprite.tween = null;
          }
          sprite.play('gate-block');
          sprite.isClosed = true;
        }
      });
    }

    // TODO: Add a return here if the player is recovering from armor break
    if (player.armorRecovery) {
      return;
    }

    // bile
    if (isPointInRect(player, g.bile)) {
      let stillAlive = player.takeHit(config.BILE);
      if (stillAlive) {
        g.bile.knockDown();
      }
    }

    // nanite expanders
    if (layers[config.EXPANDERS]) {
      let layer = layers[config.EXPANDERS];
      _.each(layer.groups.tiles, (sprite) => {
        if (!sprite.anims.isPlaying) { return; }
        let progress = sprite.anims.getProgress();
        // let rect = new Phaser.Geom.Rectangle(player.x - player.width / 2, player.y - player.height / 2, player.width, player.height);
        let rect = SpriteToRect(player);
        if (sprite.anims.getCurrentKey() === 'nanite-expander-open' && progress > 0.4) {
          let circ = new Phaser.Geom.Circle(sprite.x, sprite.y, config.EXPANDERS_RADIUS * progress);
          if (Phaser.Geom.Intersects.CircleToRectangle(circ, rect)) {
            player.takeHit(config.EXPANDERS);
          }
        }
        if (sprite.anims.getCurrentKey() === 'nanite-expander-rotate') {
          let circ = new Phaser.Geom.Circle(sprite.x, sprite.y, config.EXPANDERS_RADIUS);
          if (Phaser.Geom.Intersects.CircleToRectangle(circ, rect)) {
            player.takeHit(config.EXPANDERS);
          }
        }
        if (sprite.anims.getCurrentKey() === 'nanite-expander-close') {
          let inverseProgress = ~~((1 - progress) * 100) / 100;
          if (progress < 0.6) {
            let circ = new Phaser.Geom.Circle(sprite.x, sprite.y, config.EXPANDERS_RADIUS * inverseProgress);
            if (Phaser.Geom.Intersects.CircleToRectangle(circ, rect)) {
              player.takeHit(config.EXPANDERS);
            }
          }
        }
      });
    }

    // zapper wall watch
    if (layers[config.ZAPPER_WALLS]) {
      let layer = layers[config.ZAPPER_WALLS];
      let triggers = layer.groups.triggers;
      let highlights = layer.groups.highlights;
      _.each(triggers, (trigger, i) => {
        if (!trigger.anims.isPlaying &&
            !highlights[i].anims.isPlaying &&
            isPointInRect(player, SpriteToRect(trigger.hit))) {
          highlights[i].play(highlights[i].animKey);
          trigger.timer = g.time.delayedCall(1000, () => {
            trigger.timer.remove(false);
            trigger.timer.destroy();
            trigger.timer = null;
            trigger.play(trigger.animKey);
            soundManager.playSound('electric-wall');
          });
        } else if (trigger.anims.isPlaying && trigger.anims.getProgress() > 0.1 && trigger.anims.getProgress() < 0.5 && isPointInRect(player, SpriteToRect(trigger.hit))) {
          player.takeHit(config.ZAPPER_WALLS);
        }
      });
    } // end zapper wall watch

    // electric fence watch
    if (layers[config.ELECTRIC_GATE]) {
      let layer = layers[config.ELECTRIC_GATE];
      let hazzards = layer.groups.hazzards;
      _.each(hazzards, (zap) => {
        if (zap.alpha === 1 && isPointInRect(player, SpriteToRect(zap))) {
          player.takeHit(config.ELECTRIC_GATE);
        }
      });
    }
  }
  showBeeMoneyText (count, points) {
    let g = this.g;
    let player = g.player;

    let str = `X${count}  +${points}`;
    
    let text = g.add.text(player.x, player.y, str, { fontFamily: "FredBurger Black", fontSize: (44) +"px", color: "#ff4f8d", align: 'center' })
    text.setStroke('#FFF', 12);
    if (player.x > config.CENTER_X) {
      text.setOrigin(1, 0.5);
    } else {
      text.setOrigin(0.5, 0.5);
    }
    this.beeMoneyText.push(text);
    text.tween = g.add.tween({
      targets: text,
      y: '-=' + 200,
      duration: 2000,
      onComplete: () => {
        text.setActive(false);
        text.setVisible(false);
        for (let i = this.beeMoneyText.length - 1; i > -1; i--) {
          let t = this.beeMoneyText[i];
          if (!t.active) {
            // console.log('splice bee money text array');
            t.destroy();
            this.beeMoneyText.splice(i, 1);
          }
        }
      }
    });
  }
  bringBeeMoneyTextToTop () {
    let g = this.g;
    _.each(this.beeMoneyText, (text) => {
      g.children.bringToTop(text);
    });
  }
  resetLevelY () {
    let {
      layers
    } = this.activeLevel;

    _.each(layers, (layer) => {
      _.each(layer.groups, (group) => {
        _.each(group, (sprite) => {
          sprite.y = sprite.resetY;
        });
      });
    });
  }
  tween (level) {
    let g = this.g;
    let {
      layers
    } = level;
    let targets = [];

    _.each(layers, (layer) => {
      let groupArray = [];
      _.each(layer.groups, (group) => {
        groupArray.push(group);
      });
      groupArray = _.flatten(groupArray);
      targets.push(groupArray);
    });
    targets = _.flatten(targets);

    if (level.text) {
      targets.push(level.text);
    }
    if (level.textImage) {
      targets.push(level.textImage);
    }

    g.tweens.add({
      targets: targets,
      y: '+=' + config.HEIGHT,
      duration: config.TRANSITION_DURATION,
      ease: 'Sine.easeOut'
    });
  }
  destroyLevel (level) {
    let {
      layers
    } = level;

    if (level.text) {
      level.text.destroy();
      level.text = null;
    }
    if (level.textImage) {
      level.textImage.destroy();
      level.textImage = null;
    }
    _.each(layers, (layer) => {
      if (layer.timer) {
        layer.timer.remove(false);
        layer.timer.destroy();
        // console.log('destroyed layer timer');
      }
      _.each(layer.groups, (group) => {
        _.each(group, (sprite) => {
          if (sprite.timer) {
            // console.log('destroy timer');
            sprite.timer.remove(false);
            sprite.timer.destroy();
          }
          if (sprite.tween) {
            sprite.tween.stop();
            // console.log('tween destroyed');
          }
          sprite.destroy();
        });
        group.length = 0;
      });
    });

    // console.log('LevelManager.destroyLevel', _.clone(this.scroll));
  }
  checkAllTiles (point) {
    let {
      layers,
      exit
    } = this.activeLevel;

    // check for the exit
    if (isPointInRect(point, exit)) {
      // return config.EXIT;
      return { layerName: config.EXIT };
    }
    for (let name in layers) {
      if (IGNORED_LAYERS.indexOf(name) > -1) {
        continue;
      }
      if (name === config.GATE && !layers[name].isClosed) {
        continue;
      }
      let layer = layers[name];
      for (let sprite of layer.groups.tiles) {
        if (name === config.GATE_BLOCKS && !sprite.isClosed) {
          continue;
        }
        let rect = SpriteToRect(sprite);
        if (isPointInRect(point, rect)) {
          return sprite;
        }
      }
    }

    // check for ghosting off the board
    if (point.x > config.WIDTH || point.x < 0 || point.y > this.height || point.y < 0) {
      console.warn('checkAllTiles GHOSTING OFF THE MAP');
      // return config.WALL;
      return { layerName: config.WALL };
    }

    return false;
  }
  checkLayerTiles (point, layer) {
    for (let sprite of layer.groups.tiles) {
      let rect = SpriteToRect(sprite);
      if (isPointInRect(point, rect)) {
        return sprite;
      }
    }
    // check for ghosting off the board
    if (point.x > config.WIDTH || point.x < 0 || point.y > this.height || point.y < 0) {
      console.warn('checkLayerTiles GHOSTING OFF THE MAP');
      return -1;
    }
    return false;
  }
  closeGate () {
    let g = this.g;
    let {
      layers
    } = this.activeLevel;
    let gate = layers[config.GATE];
    if (gate.isClosed) {
      return;
    }
    gate.isClosed = true;
    _.each(gate.groups.tiles, (sprite, i) => {
      g.time.delayedCall(config.GATE_SPEED + config.GATE_SPEED * i, () => {
        sprite.play('gate-block');
        soundManager.playSound('wall-fill');
      });
    });
  }
  paint (layerName, data, collection, yOffset = 0) {
    let g = this.g;
    _.each(data, (frameIndex, index) => {
      frameIndex--;

      let x = (index % config.MAP_X_COUNT) * TILE_SIZE;
      let y = ~~(index / config.MAP_X_COUNT) * TILE_SIZE;

      if (this.frames[frameIndex]) {
        let sprite;
        sprite = g.add.sprite(x + config.TILE_X_OFFSET + TILE_SIZE_HALF, y + TILE_SIZE_HALF + yOffset, 'tilesheet');
        sprite.setScale(0.5);
        sprite.setFrame(this.frames[frameIndex].filename);
        sprite.resetY = y + TILE_SIZE_HALF;
        sprite.layerName = layerName;
        if (layerName === config.FLOOR) {
          sprite.setAlpha(config.FLOOR_ALPHA);
        }
        collection.push(sprite);
      } else {
        // console.log('No Frame for frame index', frameIndex);
      }
    });
  }
  setCamera () {
    let g = this.g;

    g.cameras.main.setBounds(0, 0, this.width, this.height);
    g.cameras.main.setScroll(0, this.height);

    // console.log('LevelManager.setCamera: this.height', this.height - config.HEIGHT);
    if (this.scroll.transition !== 0) {
      this.scroll.offset += this.scroll.transition - (this.height - config.HEIGHT);
    }

    // console.log('LevelManager.setCamera', _.clone(this.scroll));
  }
  get width () {
    return config.MAP_WIDTH;
  }
  get height () {
    return this.activeLevel.height;
  }
  get startY () {
    return this.height - TILE_SIZE_HALF;
  }
  get startX () {
    return config.CENTER_X;
  }
}

export default LevelManager;
